module.exports = __webpack_public_path__ + "static/media/Main_main4.c92b3397.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Main/assets/Main_main4.jpeg
// module id = 548
// module chunks = 0